import script from "./PredefinedGeometriesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PredefinedGeometriesModal.vue?vue&type=script&lang=ts&setup=true"

import "./PredefinedGeometriesModal.vue?vue&type=style&index=0&id=591eda1b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591eda1b"]])

export default __exports__